import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

//Store our OAuth key in Vuex. 
//ONLY IF 3M lets us use our own authentication system.

export default new Vuex.Store({
  state: {

  },
  mutations: {

  },
  actions: {

  }
})
